"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var iframe_app_bi_logger_1 = require("@wix/iframe-app-bi-logger");
var web_bi_logger_1 = require("@wix/web-bi-logger");
var wix_sdk_1 = require("../polyfills/wix-sdk");
var getOrigCompId = function () { return wix_sdk_1.default.Utils.getOrigCompId(); };
var getCompId = function () { return wix_sdk_1.default.Utils.getCompId(); };
var getInstanceValue = function (value) { return wix_sdk_1.default.Utils.getInstanceValue(value); };
var BI_DEFAULTS = {
    src: 68,
    comp_id: getOrigCompId() || getCompId(),
    instance_id: getInstanceValue('instanceId'),
};
exports.extendEventsUouEvent = function (event) { return (__assign({ msid: getInstanceValue('biToken') || getInstanceValue('originInstanceId') || '00000000-0000-0000-0000-000000000000', visitor_id: getInstanceValue('aid') || getInstanceValue('uid') }, event)); };
exports.extendEventsUsersEvent = function (event) { return (__assign({ msid: getInstanceValue('biToken') || getInstanceValue('originInstanceId') || '00000000-0000-0000-0000-000000000000' }, event)); };
exports.createWebBiLogger = function (endpoint) {
    var defaults = __assign({}, BI_DEFAULTS);
    return web_bi_logger_1.default
        .factory({ endpoint: endpoint })
        .updateDefaults(defaults)
        .logger();
};
exports.createIframeAppBiLogger = function (endpoint) {
    return iframe_app_bi_logger_1.iframeAppBiLoggerFactory(wix_sdk_1.default, { endpoint: endpoint })
        .updateDefaults(BI_DEFAULTS)
        .logger();
};
exports.createUoUBiLoggerWithBiParams = function (_a) {
    var wixCodeApi = _a.wixCodeApi, platformAPIs = _a.platformAPIs, compId = _a.compId, user = _a.user;
    return getBiLogger(platformAPIs)
        .updateDefaults({
        comp_id: compId,
        _viewMode: wixCodeApi.window.viewMode.toLowerCase(),
    })
        .withUoUContext({
        msid: platformAPIs.bi.metaSiteId,
        visitorId: platformAPIs.bi.visitorId,
        siteMemberId: user.uid || '',
    })
        .logger();
};
var getBiLogger = function (platformAPIs) {
    var logger = platformAPIs.biLoggerFactory();
    if (logger.factory) {
        logger = logger.factory();
    }
    return logger;
};
exports.createUserBiLoggerWithBiParams = function (_a) {
    var compId = _a.compId, platformAPIs = _a.platformAPIs, appParams = _a.appParams;
    return getBiLogger(platformAPIs)
        .updateDefaults({
        src: 68,
        msid: platformAPIs.bi.metaSiteId || '00000000-0000-0000-0000-000000000000',
        instance_id: appParams.instanceId,
        comp_id: compId,
    })
        .logger();
};
